import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { BrowserRouter } from 'react-router-dom';
// import Main from './Admin/Main';
// import Bot from './kistartcareers/Bot';
// import KC from './kistartcareers/KC';
// import Mainpage from './kistartcareers/Mainpage';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <BrowserRouter>
  <React.StrictMode>
   <App /> 
    {/* <Mainpage/> */}
    {/* <Bot/> */}
    {/* <Main/> */}
  </React.StrictMode>
  // </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
